import Share from './share';

const shareConfig = {
  name: 'share',
  class: Share,
  querySelector: {
    shareToggle: '.share-toggle',
    shareMenu: '.share-menu',
    shareLinkComments: '.share-link-comments',
  },
  querySelectorAll: {},
  options: {},
};

export default shareConfig;
